import EventEmitter from 'eventemitter2';
const errorEvent = 'app.error';

export class ErrorService extends EventEmitter {
  constructor() {
    'ngInject';

    super();
  }

  clear() {
    this.errors = null;
    this.emit(errorEvent, this.errors);
  }

  appendError(e) {
    this.errors = (this.errors || []).concat(this.formatError(e));
    this.emit(errorEvent, this.errors);
  }

  error(e) {
    this.errors = this.formatError(e);
    this.emit(errorEvent, this.errors);
  }

  formatError(e) {
    if (!angular.isArray(e)) {
      e = [e];
    }
    return e.map((err) => {
      if (angular.isString(err)) {
        return {
          message: err
        };
      }
      if (!err.message) {
        err.message = 'app.error.unknown';
      }
      return err;
    });
  }

  offError(listener) {
    this.off(errorEvent, listener);
  }

  onError(listener) {
    this.on(errorEvent, listener);
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-error-handling/src/error.service.js